import './App.css';

import About from './Components/about'
import Projects from './Components/projects'
import Skills from './Components/skills'
import Experience from './Components/experience'
import Contact from './Components/contact'
import Navbar from './Components/navbar'
import ParticlesComponent from './Components/particleBackground';

function App() {
  return (
    <><main className="text-gray-400 bg-gray-900 body-font">
      <ParticlesComponent id="tsparticles" />
      <Navbar />
      <About />
      <Projects />
      <Skills />
      <Experience />
      <Contact />
    </main>
      <div className="relative footer-section">
        <h1 className="footer-section"> &copy; 2025 Moamen Ibrahim </h1>
      </div>
    </>
  );
}

export default App;
